enum LanguageLocale {
  EN_US = "en_US",
  EN_GB = "en_GB",
  GERMAN = "de"
}

export default LanguageLocale;
